<template>
  <div class="grey lighten-5" style="min-height: 100vh; margin-top: 30px;">

  
    <v-container v-if="post">
      <!-- Botón volver -->
      <v-btn text color="grey darken-4" class="mb-3" @click="$router.push('/blog')">
        <v-icon left>mdi-arrow-left</v-icon> Volver al Blog

      </v-btn>

      <!-- Card principal -->
      <v-card class="mb-4">
        <!-- Header con categoría + autor -->
        <v-card-title class="pb-1">
          <v-chip small dark class="mr-2" v-if="post.category"
            :style="{ backgroundColor: post.category.color || '#424242' }">
            <v-icon left small v-if="post.category.icon">{{ post.category.icon }}</v-icon>
            {{ post.category.name }}
          </v-chip>
          <v-spacer></v-spacer>
          <div class="d-flex align-center">
            <v-icon small color="grey" class="mr-1">mdi-account</v-icon>
            <span class="caption font-weight-medium">{{ post.user ? post.user.name : 'Admin' }}</span>
            <span class="caption grey--text ml-3">
              <v-icon small>mdi-calendar</v-icon>
              {{ formatDate(post.created_at) }}
            </span>
          </div>
        </v-card-title>

        <v-card-text class="pt-2">
          <!-- Grilla 2x2 con layout personalizado -->
          <v-row>
            <v-col v-for="item in visibleSections" :key="item.section" :cols="12" :md="sectionCols(item.section)">
              <div class="section-box rounded pa-4" :style="{ backgroundColor: item.color }">

                <!-- TEXT -->
                <div v-if="item.section === 'text'">
                  <h1 class="text-h5 font-weight-bold mb-3">{{ post.title }}</h1>
                  <div class="post-body" v-html="post.body"></div>
                  <div class="mt-4">
                    <v-btn :color="liked ? 'red' : 'grey'" text small @click="toggleLike">
                      <v-icon left small>{{ liked ? 'mdi-heart' : 'mdi-heart-outline' }}</v-icon>
                      {{ post.likes_count || 0 }} Me Gusta
                    </v-btn>
                    <v-btn small outlined color="teal" class="ml-2" @click="suscribirse"
                      :loading="subscribing" :disabled="yaSubscrito">
                      <v-icon left small>{{ yaSubscrito ? 'mdi-bell-check' : 'mdi-bell-plus' }}</v-icon>
                      {{ yaSubscrito ? 'Suscrito' : 'Suscribirme' }}
                    </v-btn>
                  </div>
                </div>

                <!-- IMAGES -->
                <div v-if="item.section === 'images'">
                  <v-img :src="selectedImage" max-height="350" contain
                    class="rounded grey lighten-3 mb-2" style="cursor: pointer;"
                    @click="dialogFullImage = true"></v-img>
                  <p v-if="selectedCaption" class="text-center mb-2 mt-1">
                    <v-chip small outlined :color="post.category.color || '#424242'">
                      <v-icon left small>mdi-text-short</v-icon>
                      {{ selectedCaption }}
                    </v-chip>
                  </p>
                  <v-row dense v-if="imageUrls.length > 1">
                    <v-col cols="3" v-for="(url, i) in imageUrls" :key="i">
                      <v-card outlined
                        :class="['thumb-card', { 'selected-thumb': selectedIndex === i }]"
                        @click="selectedIndex = i" style="cursor: pointer;">
                        <v-img :src="url" height="55" contain></v-img>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>

                <!-- VIDEO -->
                <div v-if="item.section === 'video'">
                  <iframe :src="embedVideoUrl" width="100%" height="300" frameborder="0"
                    allowfullscreen style="border-radius: 8px;"></iframe>
                </div>

                <!-- COMMENTS -->
                <div v-if="item.section === 'comments'">
                  <p class="subtitle-1 font-weight-medium mb-2">
                    <v-icon small>mdi-comment-multiple</v-icon>
                    Comentarios ({{ post.comments_count || 0 }})
                  </p>
                  <v-divider class="mb-3"></v-divider>

                  <!-- Formulario nuevo comentario -->
                  <div v-if="isLoggedIn" class="mb-4">
                    <v-textarea v-model="newComment" label="Escribir un comentario..."
                      rows="2" outlined dense hide-details class="mb-2"></v-textarea>
                    <v-btn small color="grey darken-3" dark :loading="sendingComment"
                      :disabled="!newComment.trim()" @click="enviarComentario">
                      <v-icon left small>mdi-send</v-icon> Comentar
                    </v-btn>
                  </div>
                  <v-alert v-else type="info" text dense>
                    <a href="#" @click.prevent="abrirLoginParaComentar">Iniciar sesión</a> para comentar.
                  </v-alert>

                  <!-- Lista de comentarios -->
                  <div v-for="comment in comments" :key="comment.id" class="mb-3">
                    <div class="d-flex align-start">
                      <v-icon small color="grey" class="mr-2 mt-1">mdi-account-circle</v-icon>
                      <div>
                        <span class="caption font-weight-bold">{{ comment.user ? comment.user.name : 'Usuario' }}</span>
                        <span class="caption grey--text ml-2">{{ formatDate(comment.created_at) }}</span>
                        <p class="body-2 mb-1 mt-1">{{ comment.body }}</p>
                      </div>
                    </div>
                    <v-divider class="ml-7"></v-divider>
                  </div>

                  <p v-if="!comments.length" class="caption grey--text">Sé el primero en comentar.</p>
                </div>

              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- Loading -->
    <v-container v-else>
      <v-row justify="center" class="mt-10">
        <v-progress-circular indeterminate color="grey darken-3" size="50"></v-progress-circular>
      </v-row>
    </v-container>

    <!-- Dialog imagen completa -->
    <v-dialog v-model="dialogFullImage" max-width="1000">
      <v-card color="black" flat>
        <v-btn icon dark absolute top right @click="dialogFullImage = false" style="z-index:1;">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-img :src="selectedImage" contain max-height="80vh"></v-img>
      </v-card>
    </v-dialog>

    <!-- Popup Like después de 60s -->
    <blog-like-prompt v-model="likePromptDialog" :post-id="post ? post.id : null"
      @liked="onLikedFromPrompt"></blog-like-prompt>

    <!-- Login dialog (sin redirección) -->
    <blog-login-dialog v-model="showLoginDialog"
      @login-exitoso="onLoginExitoso"
      @cambiar-a-registro="cambiarARegistro">
    </blog-login-dialog>

    <!-- Register dialog -->
    <blog-register-dialog v-model="showRegisterDialog"
      @registro-exitoso="onLoginExitoso"
      @cambiar-a-login="cambiarALogin">
    </blog-register-dialog>

    <!-- Snackbar: indicar que necesita login para suscribirse -->
    <v-snackbar v-model="snackLogin" :timeout="6000" color="info" bottom>
      Para suscribirte, inicia sesión desde el botón flotante abajo a la derecha.
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackLogin = false">OK</v-btn>
      </template>
    </v-snackbar>

    <!-- Snackbar: suscripción exitosa -->
    <v-snackbar v-model="snackSubscribed" :timeout="4000" color="success" bottom>
      {{ snackSubscribedText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackSubscribed = false">OK</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import forumService from '@/services/forumService.js';
import BlogLikePrompt from '@/components/forum/BlogLikePrompt.vue';
import BlogLoginDialog from '@/components/forum/BlogLoginDialog.vue';
import BlogRegisterDialog from '@/components/forum/BlogRegisterDialog.vue';

export default {
  name: 'BlogDetailV',
  components: { BlogLikePrompt, BlogLoginDialog, BlogRegisterDialog },
  props: {
    url_post: { type: [String, Number], required: true }
  },
  data() {
    return {
      post: null,
      comments: [],
      newComment: '',
      sendingComment: false,
      liked: false,
      selectedIndex: 0,
      dialogFullImage: false,
      likePromptDialog: false,
      likeTimer: null,
      showLoginDialog: false,
      showRegisterDialog: false,
      pendingAction: null,
      yaSubscrito: false,
      subscribing: false,
      pendingSubscription: false,
      snackLogin: false,
      snackSubscribed: false,
      snackSubscribedText: ''
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.estaLogueado;
    },
    defaultLayout() {
      return [
        { section: 'text', color: '#E3F2FD' },
        { section: 'images', color: '#E8F5E9' },
        { section: 'video', color: '#FFF3E0' },
        { section: 'comments', color: '#F3E5F5' }
      ];
    },
    layoutOrder() {
      return this.post.layout_order || this.defaultLayout;
    },
    hasImages() {
      return this.imageUrls.length > 0;
    },
    hasVideo() {
      return !!this.post.video_url;
    },
    visibleSections() {
      return this.layoutOrder.filter(item => {
        if (item.section === 'text') return true;
        if (item.section === 'comments') return true;
        if (item.section === 'images') return this.hasImages;
        if (item.section === 'video') return this.hasVideo;
        return false;
      });
    },
    imageUrls() {
      if (!this.post || !this.post.images) return [];
      return this.post.images.map(img => forumService.getImageUrl(this.post.id, img.img_url));
    },
    selectedImage() {
      if (!this.imageUrls.length) return '';
      return this.imageUrls[this.selectedIndex] || this.imageUrls[0];
    },
    selectedCaption() {
      if (!this.post || !this.post.images || !this.post.images.length) return '';
      const img = this.post.images[this.selectedIndex];
      return img ? (img.caption || '') : '';
    },
    embedVideoUrl() {
      if (!this.post || !this.post.video_url) return '';
      const url = this.post.video_url;
      const ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\s]+)/);
      if (ytMatch) return 'https://www.youtube.com/embed/' + ytMatch[1];
      const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
      if (vimeoMatch) return 'https://player.vimeo.com/video/' + vimeoMatch[1];
      return url;
    }
  },
  mounted() {
    this.cargarPost();
    // Timer: mostrar popup de like después de 60 segundos
    const key = 'likePrompt_' + this.url_post;
    if (!sessionStorage.getItem(key)) {
      this.likeTimer = setTimeout(() => {
        this.likePromptDialog = true;
        sessionStorage.setItem(key, '1');
      }, 30000);
    }
  },
  watch: {
    isLoggedIn(val) {
      if (val && this.pendingSubscription) {
        this.pendingSubscription = false;
        this.ejecutarSuscripcion();
      }
    }
  },
  beforeDestroy() {
    if (this.likeTimer) {
      clearTimeout(this.likeTimer);
    }
  },
  methods: {
    cargarPost() {
      forumService.getPost(this.url_post).then(res => {
        this.post = res.data;
        // Extraer comentarios del post (vienen en la relación)
        if (this.post.comments) {
          this.comments = this.post.comments;
        }
        // Verificar si ya está suscrito a la categoría del post
        this.verificarSuscripcion();
      }).catch(() => {
        this.$router.push('/blog');
      });
    },
    verificarSuscripcion() {
      if (!this.isLoggedIn || !this.post || !this.post.category) return;
      forumService.misSuscripciones().then(res => {
        const subs = res.data || [];
        this.yaSubscrito = subs.some(s => s.category_id === this.post.category.id);
      }).catch(() => {});
    },
    enviarComentario() {
      if (!this.newComment.trim()) return;
      this.sendingComment = true;
      forumService.saveComentario(this.post.id, { body: this.newComment }).then(res => {
        this.comments.unshift(res.data.comment);
        this.newComment = '';
        if (this.post.comments_count !== undefined) {
          this.post.comments_count++;
        }
      }).catch(() => {
        // Error silencioso o mostrar snackbar
      }).finally(() => {
        this.sendingComment = false;
      });
    },
    toggleLike() {
      if (!this.isLoggedIn) {
        this.pendingAction = 'like';
        this.showLoginDialog = true;
        return;
      }
      forumService.togglePostLike(this.post.id).then(res => {
        this.liked = res.data.liked;
        if (res.data.liked) {
          this.post.likes_count = (this.post.likes_count || 0) + 1;
        } else {
          this.post.likes_count = Math.max((this.post.likes_count || 0) - 1, 0);
        }
      });
    },
    onLikedFromPrompt() {
      this.liked = true;
      this.post.likes_count = (this.post.likes_count || 0) + 1;
    },
    abrirLoginParaComentar() {
      this.pendingAction = 'comment';
      this.showLoginDialog = true;
    },
    onLoginExitoso() {
      this.showLoginDialog = false;
      this.showRegisterDialog = false;
      if (this.pendingAction === 'like') {
        this.toggleLike();
      }
      this.pendingAction = null;
    },
    cambiarARegistro() {
      this.showLoginDialog = false;
      this.$nextTick(() => { this.showRegisterDialog = true; });
    },
    cambiarALogin() {
      this.showRegisterDialog = false;
      this.$nextTick(() => { this.showLoginDialog = true; });
    },
    suscribirse() {
      if (!this.isLoggedIn) {
        this.pendingSubscription = true;
        this.snackLogin = true;
        return;
      }
      this.ejecutarSuscripcion();
    },
    ejecutarSuscripcion() {
      if (!this.post || !this.post.category) return;
      this.subscribing = true;
      forumService.subscribirCategoria({ category_id: this.post.category.id })
        .then(res => {
          this.yaSubscrito = true;
          this.snackSubscribedText = res.data.message || 'Suscripción exitosa';
          this.snackSubscribed = true;
        })
        .catch(err => {
          if (err.response && err.response.status === 409) {
            this.yaSubscrito = true;
            this.snackSubscribedText = 'Ya estás suscrito a esta categoría';
            this.snackSubscribed = true;
          }
        })
        .finally(() => { this.subscribing = false; });
    },
    sectionCols(section) {
      const total = this.visibleSections.length;
      if (total <= 1) return 12;
      if (total === 2) return 6;
      if (total === 3) {
        const idx = this.visibleSections.findIndex(item => item.section === section);
        return idx < 2 ? 6 : 12;
      }
      return 6;
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleDateString('es', { day: '2-digit', month: 'short', year: 'numeric' });
    }
  }
};
</script>

<style scoped>
.section-box {
  min-height: 120px;
  height: 100%;
}
.post-body {
  line-height: 1.8;
}
.post-body p {
  margin-bottom: 10px;
}
.thumb-card {
  opacity: 0.6;
  transition: all 0.2s ease;
  cursor: pointer;
}
.thumb-card:hover {
  opacity: 0.9;
}
.selected-thumb {
  border: 2px solid #009688 !important;
  opacity: 1 !important;
}
</style>
